import axios from "../httpClient";

function getZendeskTicketConfiguration() {
  return axios.get("/configuration/zendesk/ticket");
}

function updateZendeskTicketConfiguration(api, configuration) {
  return axios.patch(`/configuration/zendesk/ticket`, {
    api,
    configuration,
  });
}

function getInstanceMappings() {
  return axios.get("/configuration/zendesk/instance-mapping");
}

function updateInstanceMapping(product, instanceName) {
  return axios.patch(`/configuration/zendesk/instance-mapping/${product}`, {
    instanceName,
  });
}

function getInstances() {
  return axios.get("/configuration/zendesk/instances");
}

function checkTicketExists({ zendeskId, product, instance }) {
  return axios.get(
    `/zendesk/ticket/${zendeskId}/check?product=${product}&instance=${instance}`,
  );
}

export default {
  getZendeskTicketConfiguration,
  updateZendeskTicketConfiguration,
  getInstanceMappings,
  updateInstanceMapping,
  getInstances,
  checkTicketExists,
};
